<template>
  <div id="detail" class="ic-page">
    <div style="text-align: center;">
      <img src="@/assets/serviceImg/service/Frame_4121@2x.png" alt="住院协作" class="ic-banner-img" />
    </div>

    <section class="ic-section">
      <div class="ic-section-title">服务介绍</div>
      <div class="ic-section-content">{{ pageCopy.intro }}</div>
    </section>

    <section class="ic-section">
      <div class="ic-section-title">所需材料</div>
      <div class="ic-section-content">{{ pageCopy.materials }}</div>
    </section>

    <section class="ic-section">
      <div class="ic-section-title">使用规则</div>
      <ul class="ic-rule-list">
        <li v-for="item in pageCopy.rules" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="ic-section">
      <div class="ic-section-title">使用方式</div>
      <div class="ic-section-content">
        {{ pageCopy.usageBefore }}
        <a :href="hotlineTel" class="ic-hotline-link">{{ hotlineDisplay }}</a>
        {{ pageCopy.usageAfter }}
      </div>
    </section>

    <div class="ic-action-bar">
      <button
        type="button"
        class="ic-action-btn"
        :class="{ 'ic-action-btn--disabled': !equityCanUse }"
        :disabled="!equityCanUse"
        @click="makeanappointment"
      >{{ getServiceBtnText }}</button>
    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p class="modal-tip">该项权益需开通以下服务权益</p>
        <div class="modal-card" @click="equity">
          <img class="modal-card-bg" src="@/assets/img/qykbj.png" alt="" />
          <h3 class="modal-card-title">大救星-星健康权益卡</h3>
          <div class="modal-card-desc">多项健康权益尊享，为您健康守护</div>
          <div class="modal-card-btn">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaiheServiceCopy } from '@/utils/taiheServiceCopy'
import equityUsedCountMixin from '@/mixins/equityUsedCountMixin'

/** 24 小时救援热线 */
const RESCUE_HOTLINE_DISPLAY = '+86-10-89180868'
const RESCUE_HOTLINE_TEL = 'tel:+861089180868'

/** 住院协作统一展示文案 */
const INPATIENT_COLLABORATION_COPY = Object.freeze({
  intro:
    '针对心血管疾病需住院用户，核验住院单后，协助安排公立二级及以上医院专科床位，全程远程协助办理入院事宜。',
  materials: '实名身份信息、二级及以上公立医院心血管专科开具住院单',
  rules: [
    '使用前提：下载【大救星健康版】APP，实名注册开通服务，持有有效住院单；',
    '服务范围：北上广深、成都、杭州、苏州等全国公立二级及以上医院；',
    '服务时效：收齐材料后平均10个工作日安排床位；',
    '使用次数：合同有效期内仅限本人使用1次；',
    '备注：用户主动取消服务，视同权益已消耗，医疗费用由用户自行承担。'
  ],
  usageBefore: '登录【大救星健康版】APP一键救援，或拨打24小时热线 ',
  usageAfter: '提交需求，客服核验权益、收集材料，专员对接完成入院安排。'
})

export default {
  equityServiceKey: 'inpatientCollaboration',
  mixins: [equityUsedCountMixin],
  data() {
    return {
      showModal: false,
      equityinfoType: false,
      hotlineDisplay: RESCUE_HOTLINE_DISPLAY,
      hotlineTel: RESCUE_HOTLINE_TEL
    }
  },
  computed: {
    /**
     * 根据 productId 返回住院协作页面文案（保留 id 判断，当前各 id 统一展示同一套文案）
     * @returns {{ intro: string, materials: string, rules: string[], usageBefore: string, usageAfter: string }}
     */
    pageCopy() {
      const productId = this.$route.query.productId
      if (productId === '949' || productId === 949) {
        return INPATIENT_COLLABORATION_COPY
      }
      // 951、1040 及未传 productId 等：当前统一展示新文案
      getTaiheServiceCopy(productId, 'inpatientCollaboration', INPATIENT_COLLABORATION_COPY.intro)
      return INPATIENT_COLLABORATION_COPY
    }
  },
  created() {
    document.title = '住院协作'
    this.equityinfoType = localStorage.getItem('equityinfo')
  },
  beforeCreate() {
    document.querySelector('#app').setAttribute('style', 'background-color:#F2F3F5')
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px'
    }
  },
  methods: {
    /**
     * 获取服务：校验剩余次数后跳转一键救援
     */
    makeanappointment() {
      this.goRescueWithCaseType()
    },
    /**
     * 跳转权益卡介绍
     */
    equity() {
      this.$router.push({
        path: '/equity',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="less">
.ic-page {
  min-height: 100vh;
  padding: 1rem 0.5rem calc(76px + env(safe-area-inset-bottom));
  background: #f2f3f5;
  box-sizing: border-box;
}

.ic-banner-img {
  width: 100px;
  height: 100px;
  vertical-align: middle;
  margin-right: 0.5vw;
  margin-bottom: 1rem;
}

.ic-section {
  margin-bottom: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.ic-section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.ic-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #00c275 0%, #4ecdc4 100%);
}

.ic-section-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.75;
  text-align: justify;
}

.ic-hotline-link {
  color: #00bb82;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.ic-hotline-link:active {
  opacity: 0.75;
}

.ic-rule-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ic-rule-list li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
}

.ic-rule-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00c275;
}

.ic-rule-list li:last-child {
  margin-bottom: 0;
}

.ic-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(242, 243, 245, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.ic-action-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: rgb(0, 187, 130);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ic-action-btn:active {
  opacity: 0.9;
  transform: scale(0.99);
}

.ic-action-btn--disabled,
.ic-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.modal-tip {
  margin: 0 0 20px;
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: #000000;
  cursor: pointer;
}

.modal-card {
  position: relative;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
}

.modal-card-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-card-title {
  position: absolute;
  top: 56px;
  left: 24px;
  margin: 0;
  font-size: 18px;
  color: #333333;
}

.modal-card-desc {
  position: absolute;
  top: 88px;
  left: 24px;
  font-size: 13px;
  color: #666666;
}

.modal-card-btn {
  position: absolute;
  top: 56px;
  right: 16px;
  width: 72px;
  height: 28px;
  border-radius: 16px;
  background: rgb(74, 71, 64);
  color: #f2d57a;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/detailsH5/inpatientCollaboration.vue